<div class="container" *ngIf="client && initialized">
  <div class="content">
    <app-nav-top [authService]="authService"></app-nav-top>
    <router-outlet></router-outlet>
    <app-nav-bottom [routes]="routes"></app-nav-bottom>
  </div>
</div>
